import { ShaderStore } from "@babylonjs/core";
const name = "mapPixelShader";
const shader = `precision highp float;#include<clipFragmentDeclaration>
#include<textureFragmentDeclaration>
void main(void) {#include<clipFragment>
gl_FragColor=texture(uTextures,vec3(vUvs,depth));}`;
ShaderStore.ShadersStore[name] = shader;
export const mapPixelShader = { name, shader };
//# sourceMappingURL=map.fragment.js.map